export default __webpack_public_path__ + "static/media/path.99e70b7a.png";